import map from 'lodash/map';

import {
  Offer_Funding_Source,
  Offer_Presentation_Priority,
  Offer_Presentation_Type,
} from '@occc/graphql';

export const presentationTypeLabels: Record<Offer_Presentation_Type, string> = {
  [Offer_Presentation_Type.Default]: 'Tile',
  [Offer_Presentation_Type.Hidden]: 'Hidden',
  [Offer_Presentation_Type.Banner]: 'Banner',
  [Offer_Presentation_Type.Carousel]: 'Carousel',
};

export const presentationTypeOptions = map(
  presentationTypeLabels,
  (label, value: Offer_Presentation_Type) => ({
    label,
    value,
  }),
);

export const presentationPriorityLabels: Record<Offer_Presentation_Priority, string> = {
  [Offer_Presentation_Priority.Default]: 'Category',
  [Offer_Presentation_Priority.Featured]: 'Featured',
};

export const presentationPriorityOptions = map(
  presentationPriorityLabels,
  (label, value: Offer_Presentation_Priority) => ({
    label,
    value,
  }),
);

export const offerFundingSourceOptions = map(Offer_Funding_Source, (value, label) => ({
  label,
  value,
}));
